import {
  FrequentlyAskedQuestionAnswer
} from '../../frequently-asked-question-answers/frequently-asked-question-answer/frequently-asked-question-answer';

export class FrequentlyAskedQuestion {
  id: string;
  question: string;
  frequentlyAskedQuestionAnswer: FrequentlyAskedQuestionAnswer;
}
